const { REACT_APP_VERSION, REACT_APP_ENVIRONMENT, REACT_APP_API_BASE_URL } = process.env;

const Config = {
  version: REACT_APP_VERSION,
  environment: REACT_APP_ENVIRONMENT,
  baseUrl: REACT_APP_API_BASE_URL as string,
};

export default Config;
